import React from 'react';
import SalesProfitInfo from '../../../components/chancemng/obtainorder/SalesProfitInfo';

const SalesProfitInfoContainer = ({ orderInfo, chance }) => {
  return <SalesProfitInfo orderInfo={orderInfo} chance={chance} />;
};

export default SalesProfitInfoContainer;
